// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#consentFormsWrapper{padding-bottom:10vh}.waiver{gap:12px}#waiverCount{color:#797979;font-size:1em}#waiverTop{margin-top:-40px}", ""]);
// Exports
module.exports = exports;
